
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/quickEditEngine/components/styles/componentControlWrapper.scss.css.virtualfile';
        module.exports = {"quickEditComponentControlWrapper":"_quickEditComponentControlWrapper_1kup6_1"};